import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import store from '../store';
import getHost from '../utils/host';
import urlUtils from '../utils/url';
var MICROSERVICE_API_ROUTE = 'api/microservices/v1/';
var REDIRECT = MICROSERVICE_API_ROUTE + 'redirect/';
var INVOKE = MICROSERVICE_API_ROUTE + 'invoke/';
export var invokeApp = function invokeApp(app, url) {
  var ecrionServer = getHost();
  var route = INVOKE;
  var appBackendPath = url;
  if (!appBackendPath.startsWith('/')) appBackendPath = '/' + appBackendPath;
  return "".concat(ecrionServer).concat(route).concat(app).concat(appBackendPath);
};
export var redirect = function redirect(app, url) {
  var ecrionServer = getHost() || '/';
  var route = REDIRECT;
  var appUiPath = '';
  var hashPath = '';
  var queryParameters = {}; //compose string

  if (url) {
    var _url$split = url.split('#');

    var _url$split2 = _slicedToArray(_url$split, 2);

    appUiPath = _url$split2[0];
    hashPath = _url$split2[1];

    if (appUiPath.indexOf('?') > -1) {
      //extract existing query parameters
      var parsed = urlUtils.parseUrl(appUiPath);
      queryParameters = _objectSpread({}, queryParameters, parsed.query);
      appUiPath = parsed.url;
    } else {
      appUiPath = appUiPath;
    }
  }

  var env = store.getState().userInfo.environmentName;

  if (env) {
    queryParameters.environment = env;
  }

  var token = store.getState().auth.token;

  if (token) {
    queryParameters.accessToken = token;
  } //serialize


  var queryPath = urlUtils.stringifySearchParams(queryParameters);
  if (queryPath) queryPath = '?' + queryPath;else queryPath = '';
  if (!appUiPath.startsWith('/')) appUiPath = '/' + appUiPath;
  if (hashPath) hashPath = '#' + hashPath;else hashPath = '';
  return "".concat(ecrionServer).concat(route).concat(app).concat(appUiPath).concat(queryPath).concat(hashPath);
};
var AppsUtils = {
  invokeApp: invokeApp,
  redirect: redirect
};
export default AppsUtils;